import { html } from 'lit';

// database icon

export const DatabaseSearchIcon = html`<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M3.75 9.5C3.75 6.32436 6.32436 3.75 9.5 3.75C12.6756 3.75 15.25 6.32436 15.25 9.5C15.25 12.6756 12.6756 15.25 9.5 15.25C6.32436 15.25 3.75 12.6756 3.75 9.5ZM9.5 2.25C5.49594 2.25 2.25 5.49594 2.25 9.5C2.25 13.5041 5.49594 16.75 9.5 16.75C11.2319 16.75 12.8219 16.1427 14.0689 15.1295L19.4697 20.5303C19.7626 20.8232 20.2374 20.8232 20.5303 20.5303C20.8232 20.2374 20.8232 19.7626 20.5303 19.4697L15.1295 14.0689C16.1427 12.8219 16.75 11.2319 16.75 9.5C16.75 5.49594 13.5041 2.25 9.5 2.25Z"
    fill="#77757D"
  />
</svg> `;

export const DatabasePen = html`<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M14 6.20314L5.5 15L4 20L9 18.5L17.7969 10M14 6.20314L15.3595 4.79619C16.4211 3.73461 18.1422 3.7346 19.2038 4.79619C20.2654 5.85777 20.2654 7.57894 19.2038 8.64052L17.7969 10M14 6.20314L17.7969 10"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>`;

export const DatabaseDelete = html`<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M4 6H20M16 6L15.7294 5.18807C15.4671 4.40125 15.3359 4.00784 15.0927 3.71698C14.8779 3.46013 14.6021 3.26132 14.2905 3.13878C13.9376 3 13.523 3 12.6936 3H11.3064C10.477 3 10.0624 3 9.70951 3.13878C9.39792 3.26132 9.12208 3.46013 8.90729 3.71698C8.66405 4.00784 8.53292 4.40125 8.27064 5.18807L8 6M18 6V16.2C18 17.8802 18 18.7202 17.673 19.362C17.3854 19.9265 16.9265 20.3854 16.362 20.673C15.7202 21 14.8802 21 13.2 21H10.8C9.11984 21 8.27976 21 7.63803 20.673C7.07354 20.3854 6.6146 19.9265 6.32698 19.362C6 18.7202 6 17.8802 6 16.2V6M14 10V17M10 10V17"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>`;

export const DatabaseDuplicate = html`<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M6 3.25C4.48122 3.25 3.25 4.48122 3.25 6V14C3.25 15.5188 4.48122 16.75 6 16.75H7.25V18C7.25 19.5188 8.48122 20.75 10 20.75H18C19.5188 20.75 20.75 19.5188 20.75 18V10C20.75 8.48122 19.5188 7.25 18 7.25H16.75V6C16.75 4.48122 15.5188 3.25 14 3.25H6ZM10 7.25H15.25V6C15.25 5.30964 14.6904 4.75 14 4.75H6C5.30964 4.75 4.75 5.30964 4.75 6V14C4.75 14.6904 5.30964 15.25 6 15.25H8C8.41421 15.25 8.75 15.5858 8.75 16V18C8.75 18.6904 9.30964 19.25 10 19.25H18C18.6904 19.25 19.25 18.6904 19.25 18V10C19.25 9.30964 18.6904 8.75 18 8.75H16H10C9.46561 8.75 9.00774 9.08568 8.82933 9.56024C8.68357 9.94796 8.2511 10.1441 7.86338 9.99835C7.47566 9.85259 7.27951 9.42012 7.42527 9.0324C7.81633 7.99216 8.82056 7.25 10 7.25ZM12.8871 10.489C12.6049 10.1858 12.1303 10.1688 11.8271 10.451C11.524 10.7333 11.507 11.2078 11.7892 11.511L12.4771 12.25H7.79999C7.38577 12.25 7.04999 12.5858 7.04999 13C7.04999 13.4142 7.38577 13.75 7.79999 13.75H12.4771L11.7892 14.489C11.507 14.7922 11.524 15.2667 11.8271 15.549C12.1303 15.8312 12.6049 15.8142 12.8871 15.511L14.7489 13.511C15.017 13.2231 15.017 12.7769 14.7489 12.489L12.8871 10.489Z"
    fill="#77757D"
  />
</svg> `;

export const DatabaseInsertLeft = html`<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M14 3.75C13.0335 3.75 12.25 4.5335 12.25 5.5V18.5C12.25 19.4665 13.0335 20.25 14 20.25H18C18.9665 20.25 19.75 19.4665 19.75 18.5V5.5C19.75 4.5335 18.9665 3.75 18 3.75H14ZM13.75 5.5C13.75 5.36193 13.8619 5.25 14 5.25H18C18.1381 5.25 18.25 5.36193 18.25 5.5V18.5C18.25 18.6381 18.1381 18.75 18 18.75H14C13.8619 18.75 13.75 18.6381 13.75 18.5V5.5ZM8.25 9.5C8.25 9.08579 7.91421 8.75 7.5 8.75C7.08579 8.75 6.75 9.08579 6.75 9.5V11.25H5C4.58579 11.25 4.25 11.5858 4.25 12C4.25 12.4142 4.58579 12.75 5 12.75H6.75V14.5C6.75 14.9142 7.08579 15.25 7.5 15.25C7.91421 15.25 8.25 14.9142 8.25 14.5V12.75H10C10.4142 12.75 10.75 12.4142 10.75 12C10.75 11.5858 10.4142 11.25 10 11.25H8.25V9.5Z"
    fill="#77757D"
  />
</svg> `;

export const DatabaseInsertRight = html`<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M6 3.75C5.0335 3.75 4.25 4.5335 4.25 5.5V18.5C4.25 19.4665 5.0335 20.25 6 20.25H10C10.9665 20.25 11.75 19.4665 11.75 18.5V5.5C11.75 4.5335 10.9665 3.75 10 3.75H6ZM5.75 5.5C5.75 5.36193 5.86193 5.25 6 5.25H10C10.1381 5.25 10.25 5.36193 10.25 5.5V18.5C10.25 18.6381 10.1381 18.75 10 18.75H6C5.86193 18.75 5.75 18.6381 5.75 18.5V5.5ZM17.25 9.5C17.25 9.08579 16.9142 8.75 16.5 8.75C16.0858 8.75 15.75 9.08579 15.75 9.5V11.25H14C13.5858 11.25 13.25 11.5858 13.25 12C13.25 12.4142 13.5858 12.75 14 12.75H15.75V14.5C15.75 14.9142 16.0858 15.25 16.5 15.25C16.9142 15.25 17.25 14.9142 17.25 14.5V12.75H19C19.4142 12.75 19.75 12.4142 19.75 12C19.75 11.5858 19.4142 11.25 19 11.25H17.25V9.5Z"
    fill="#77757D"
  />
</svg> `;

export const DatabaseMoveLeft = html`<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M4 4V20M8 12H20M8 12L12 8M8 12L12 16"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>`;

export const DatabaseMoveRight = html`<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M20 4V20M4 12H16M16 12L12 8M16 12L12 16"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>`;

export const DatabaseMultiSelect = html`<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M4 5L6.42929 7.42929C6.46834 7.46834 6.53166 7.46834 6.57071 7.42929L9 5"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
  />
  <path
    d="M4 11L6.42929 13.4293C6.46834 13.4683 6.53166 13.4683 6.57071 13.4293L9 11"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
  />
  <path
    d="M4 17L6.42929 19.4293C6.46834 19.4683 6.53166 19.4683 6.57071 19.4293L9 17"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
  />
  <path
    d="M12 6L20 6"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
  />
  <path
    d="M12 12L20 12"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
  />
  <path
    d="M12 18L20 18"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
  />
</svg>`;

export const DatabaseNumber = html`<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M18.5 4L12.5 20"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
  />
  <path
    d="M12 4L6 20"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
  />
  <path
    d="M20 8.5H5.5"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
  />
  <path
    d="M19 15L4 15"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
  />
</svg>`;

export const DatabaseSelect = html`<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C16.5563 20.25 20.25 16.5563 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75ZM2.25 12C2.25 6.61522 6.61522 2.25 12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12Z"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M7.46967 10.4697C7.76256 10.1768 8.23744 10.1768 8.53033 10.4697L12 13.9393L15.4697 10.4697C15.7626 10.1768 16.2374 10.1768 16.5303 10.4697C16.8232 10.7626 16.8232 11.2374 16.5303 11.5303L12.601 15.4596C12.2691 15.7916 11.7309 15.7916 11.399 15.4596L7.46967 11.5303C7.17678 11.2374 7.17678 10.7626 7.46967 10.4697Z"
  />
</svg>`;

export const DatabaseProgress = html`<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M15 4.25C15.4142 4.25 15.75 4.58579 15.75 5V6.25H18C20.0711 6.25 21.75 7.92893 21.75 10V14C21.75 16.0711 20.0711 17.75 18 17.75H15.75V19C15.75 19.4142 15.4142 19.75 15 19.75C14.5858 19.75 14.25 19.4142 14.25 19V17.75H6C3.92893 17.75 2.25 16.0711 2.25 14V10C2.25 7.92893 3.92893 6.25 6 6.25H14.25V5C14.25 4.58579 14.5858 4.25 15 4.25ZM14.25 7.75H6C4.75736 7.75 3.75 8.75736 3.75 10V14C3.75 15.2426 4.75736 16.25 6 16.25H14.25V7.75ZM15.75 16.25H18C19.2426 16.25 20.25 15.2426 20.25 14V10C20.25 8.75736 19.2426 7.75 18 7.75H15.75V16.25ZM6 9.25C6.41421 9.25 6.75 9.58579 6.75 10V14C6.75 14.4142 6.41421 14.75 6 14.75C5.58579 14.75 5.25 14.4142 5.25 14L5.25 10C5.25 9.58579 5.58579 9.25 6 9.25ZM9 9.25C9.41421 9.25 9.75 9.58579 9.75 10L9.75 14C9.75 14.4142 9.41421 14.75 9 14.75C8.58579 14.75 8.25 14.4142 8.25 14L8.25 10C8.25 9.58579 8.58579 9.25 9 9.25ZM12 9.25C12.4142 9.25 12.75 9.58579 12.75 10V14C12.75 14.4142 12.4142 14.75 12 14.75C11.5858 14.75 11.25 14.4142 11.25 14V10C11.25 9.58579 11.5858 9.25 12 9.25Z"
  />
</svg>`;

export const DatabaseSearchClose = html`<svg
  width="16"
  height="16"
  viewBox="0 0 16 16"
  xmlns="http://www.w3.org/2000/svg"
  fill="none"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M4.22872 4.22878C4.42398 4.03352 4.74057 4.03352 4.93583 4.22878L7.99996 7.29291L11.0641 4.22878C11.2593 4.03352 11.5759 4.03352 11.7712 4.22878C11.9665 4.42405 11.9665 4.74063 11.7712 4.93589L8.70707 8.00002L11.7712 11.0641C11.9665 11.2594 11.9665 11.576 11.7712 11.7713C11.5759 11.9665 11.2593 11.9665 11.0641 11.7713L7.99996 8.70713L4.93583 11.7713C4.74057 11.9665 4.42398 11.9665 4.22872 11.7713C4.03346 11.576 4.03346 11.2594 4.22872 11.0641L7.29285 8.00002L4.22872 4.93589C4.03346 4.74063 4.03346 4.42405 4.22872 4.22878Z"
  />
</svg>`;

export const DatabaseDone = html`<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M20.5322 5.97152C20.824 6.26543 20.8224 6.7403 20.5285 7.03217L9.45156 18.0322C9.15909 18.3226 8.68706 18.3226 8.3946 18.0322L3.47152 13.1433C3.17761 12.8514 3.17595 12.3765 3.46783 12.0826C3.7597 11.7887 4.23457 11.7871 4.52848 12.0789L8.92308 16.443L19.4715 5.96783C19.7654 5.67595 20.2403 5.67761 20.5322 5.97152Z"
  />
</svg>`;

const addColumnStyle = `
  width: 12px;
  height: 12px;
  fill: var(--affine-text-primary-color);
`;
export const DatabaseAddColumn = html`<svg
  viewBox="0 0 16 16"
  style=${addColumnStyle}
>
  <path
    d="M7.977 14.963c.407 0 .747-.324.747-.723V8.72h5.362c.399 0 .74-.34.74-.747a.746.746 0 00-.74-.738H8.724V1.706c0-.398-.34-.722-.747-.722a.732.732 0 00-.739.722v5.529h-5.37a.746.746 0 00-.74.738c0 .407.341.747.74.747h5.37v5.52c0 .399.332.723.739.723z"
  ></path>
</svg>`;

export const DatabaseDragIcon = html`<svg
  width="10"
  height="14"
  viewBox="0 0 10 14"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect width="10" height="14" rx="2" />
  <rect width="10" height="14" rx="2" fill-opacity="0.08" />
  <g clip-path="url(#clip0_179_9218)">
    <circle cx="3" cy="3" r="1" fill="var(--affine-icon-color)" />
    <circle cx="3" cy="6.79163" r="1" fill="var(--affine-icon-color)" />
    <circle cx="3" cy="10.5833" r="1" fill="var(--affine-icon-color)" />
    <circle cx="7" cy="3" r="1" fill="var(--affine-icon-color)" />
    <circle cx="7" cy="6.79163" r="1" fill="var(--affine-icon-color)" />
    <circle cx="7" cy="10.5833" r="1" fill="var(--affine-icon-color)" />
  </g>
  <defs>
    <clipPath id="clip0_179_9218">
      <rect width="6" height="10" transform="translate(2 2)" />
    </clipPath>
  </defs>
</svg>`;

export const DatabaseSelectionColor = html`
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C13.2426 20.25 14.25 19.2426 14.25 18V17.4C14.25 17.3802 14.25 17.3606 14.25 17.3414C14.2499 17.0272 14.2498 16.7851 14.2839 16.5698C14.4702 15.3931 15.3931 14.4702 16.5698 14.2839C16.7851 14.2498 17.0272 14.2499 17.3414 14.25C17.3606 14.25 17.3802 14.25 17.4 14.25H18C19.2426 14.25 20.25 13.2426 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75ZM2.25 12C2.25 6.61522 6.61522 2.25 12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 14.0711 20.0711 15.75 18 15.75H17.4C16.9997 15.75 16.8869 15.7523 16.8045 15.7654C16.2696 15.8501 15.8501 16.2696 15.7654 16.8045C15.7523 16.8869 15.75 16.9997 15.75 17.4V18C15.75 20.0711 14.0711 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12ZM9.25 7.5C9.25 6.80964 9.80964 6.25 10.5 6.25C11.1904 6.25 11.75 6.80964 11.75 7.5C11.75 8.19036 11.1904 8.75 10.5 8.75C9.80964 8.75 9.25 8.19035 9.25 7.5ZM14.25 8.5C14.25 7.80964 14.8096 7.25 15.5 7.25C16.1904 7.25 16.75 7.80964 16.75 8.5C16.75 9.19035 16.1904 9.75 15.5 9.75C14.8096 9.75 14.25 9.19035 14.25 8.5ZM6.25 11.5C6.25 10.8096 6.80964 10.25 7.5 10.25C8.19035 10.25 8.75 10.8096 8.75 11.5C8.75 12.1904 8.19035 12.75 7.5 12.75C6.80964 12.75 6.25 12.1904 6.25 11.5Z"
    />
  </svg>
`;

export const DatabaseExpandWide = html`<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M4.25 5C4.25 4.58579 4.58579 4.25 5 4.25H8.5C8.91421 4.25 9.25 4.58579 9.25 5C9.25 5.41421 8.91421 5.75 8.5 5.75H6.81066L9.90533 8.84467C10.1982 9.13756 10.1982 9.61244 9.90533 9.90533C9.61244 10.1982 9.13756 10.1982 8.84467 9.90533L5.75 6.81066V8.5C5.75 8.91421 5.41421 9.25 5 9.25C4.58579 9.25 4.25 8.91421 4.25 8.5V5ZM14.75 5C14.75 4.58579 15.0858 4.25 15.5 4.25H19C19.4142 4.25 19.75 4.58579 19.75 5V8.5C19.75 8.91421 19.4142 9.25 19 9.25C18.5858 9.25 18.25 8.91421 18.25 8.5V6.81066L15.1553 9.90533C14.8624 10.1982 14.3876 10.1982 14.0947 9.90533C13.8018 9.61244 13.8018 9.13756 14.0947 8.84467L17.1893 5.75H15.5C15.0858 5.75 14.75 5.41421 14.75 5ZM9.90533 14.0947C10.1982 14.3876 10.1982 14.8624 9.90533 15.1553L6.81066 18.25H8.5C8.91421 18.25 9.25 18.5858 9.25 19C9.25 19.4142 8.91421 19.75 8.5 19.75H5C4.58579 19.75 4.25 19.4142 4.25 19V15.5C4.25 15.0858 4.58579 14.75 5 14.75C5.41421 14.75 5.75 15.0858 5.75 15.5V17.1893L8.84467 14.0947C9.13756 13.8018 9.61244 13.8018 9.90533 14.0947ZM14.0947 14.0947C14.3876 13.8018 14.8624 13.8018 15.1553 14.0947L18.25 17.1893V15.5C18.25 15.0858 18.5858 14.75 19 14.75C19.4142 14.75 19.75 15.0858 19.75 15.5V19C19.75 19.4142 19.4142 19.75 19 19.75H15.5C15.0858 19.75 14.75 19.4142 14.75 19C14.75 18.5858 15.0858 18.25 15.5 18.25H17.1893L14.0947 15.1553C13.8018 14.8624 13.8018 14.3876 14.0947 14.0947Z"
    fill="#77757D"
  />
</svg> `;

export const DatabaseExpand = html`
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.4697 3.46967C11.7626 3.17678 12.2374 3.17678 12.5303 3.46967L17.5303 8.46967C17.8232 8.76256 17.8232 9.23744 17.5303 9.53033C17.2374 9.82322 16.7626 9.82322 16.4697 9.53033L12 5.06066L7.53033 9.53033C7.23744 9.82322 6.76256 9.82322 6.46967 9.53033C6.17678 9.23744 6.17678 8.76256 6.46967 8.46967L11.4697 3.46967ZM6.46967 14.4697C6.76256 14.1768 7.23744 14.1768 7.53033 14.4697L12 18.9393L16.4697 14.4697C16.7626 14.1768 17.2374 14.1768 17.5303 14.4697C17.8232 14.7626 17.8232 15.2374 17.5303 15.5303L12.5303 20.5303C12.2374 20.8232 11.7626 20.8232 11.4697 20.5303L6.46967 15.5303C6.17678 15.2374 6.17678 14.7626 6.46967 14.4697Z"
    />
  </svg>
`;

export const DatabaseCompress = html`<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M14.9887 9.74168C14.5745 9.74168 14.2387 9.40589 14.2387 8.99168V4.97832C14.2387 4.5641 14.5745 4.22832 14.9887 4.22832C15.4029 4.22832 15.7387 4.5641 15.7387 4.97832V7.18102L19.4751 3.44465C19.768 3.15175 20.2428 3.15175 20.5357 3.44465C20.8286 3.73754 20.8286 4.21241 20.5357 4.50531L16.7993 8.24168H19.002C19.4163 8.24168 19.752 8.57747 19.752 8.99168C19.752 9.40589 19.4163 9.74168 19.002 9.74168H14.9887ZM14.9887 14.2334C14.5745 14.2334 14.2387 14.5692 14.2387 14.9834V18.9967C14.2387 19.411 14.5745 19.7467 14.9887 19.7467C15.4029 19.7467 15.7387 19.411 15.7387 18.9967V16.794L19.4751 20.5304C19.768 20.8233 20.2428 20.8233 20.5357 20.5304C20.8286 20.2375 20.8286 19.7626 20.5357 19.4698L16.7993 15.7334H19.002C19.4163 15.7334 19.752 15.3976 19.752 14.9834C19.752 14.5692 19.4163 14.2334 19.002 14.2334H14.9887ZM9.66131 14.9834C9.66131 14.5692 9.32553 14.2334 8.91131 14.2334H4.89795C4.48374 14.2334 4.14795 14.5692 4.14795 14.9834C4.14795 15.3976 4.48374 15.7334 4.89795 15.7334H7.10065L3.36428 19.4698C3.07138 19.7626 3.07138 20.2375 3.36428 20.5304C3.65717 20.8233 4.13204 20.8233 4.42494 20.5304L8.16131 16.794V18.9967C8.16131 19.411 8.4971 19.7467 8.91131 19.7467C9.32553 19.7467 9.66131 19.411 9.66131 18.9967V14.9834ZM8.91131 9.74168C9.32553 9.74168 9.66131 9.40589 9.66131 8.99168V4.97832C9.66131 4.5641 9.32553 4.22832 8.91131 4.22832C8.4971 4.22832 8.16131 4.5641 8.16131 4.97832V7.18102L4.42494 3.44465C4.13204 3.15175 3.65717 3.15175 3.36428 3.44465C3.07138 3.73754 3.07138 4.21241 3.36428 4.50531L7.10065 8.24168H4.89795C4.48374 8.24168 4.14795 8.57747 4.14795 8.99168C4.14795 9.40589 4.48374 9.74168 4.89795 9.74168H8.91131Z"
    fill="#77757D"
  />
</svg> `;

export const DatabaseTableViewClose = html`
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.34314 6.34321C6.63604 6.05031 7.11091 6.05031 7.4038 6.34321L12 10.9394L16.5962 6.34321C16.8891 6.05031 17.364 6.05031 17.6569 6.34321C17.9497 6.6361 17.9497 7.11097 17.6569 7.40387L13.0607 12.0001L17.6569 16.5963C17.9497 16.8891 17.9497 17.364 17.6569 17.6569C17.364 17.9498 16.8891 17.9498 16.5962 17.6569L12 13.0607L7.4038 17.6569C7.11091 17.9498 6.63604 17.9498 6.34314 17.6569C6.05025 17.364 6.05025 16.8891 6.34314 16.5963L10.9393 12.0001L6.34314 7.40387C6.05025 7.11097 6.05025 6.6361 6.34314 6.34321Z"
    />
  </svg>
`;

export const DateTime = html`<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M8 2.75C8.41421 2.75 8.75 3.08579 8.75 3.5V4.25H15.25V3.5C15.25 3.08579 15.5858 2.75 16 2.75C16.4142 2.75 16.75 3.08579 16.75 3.5V4.25H19C20.5188 4.25 21.75 5.48122 21.75 7V9.5V19C21.75 20.5188 20.5188 21.75 19 21.75H5C3.48122 21.75 2.25 20.5188 2.25 19V9.5V7C2.25 5.48122 3.48122 4.25 5 4.25H7.25V3.5C7.25 3.08579 7.58579 2.75 8 2.75ZM15.25 5.75V6.5C15.25 6.91421 15.5858 7.25 16 7.25C16.4142 7.25 16.75 6.91421 16.75 6.5V5.75H19C19.6904 5.75 20.25 6.30964 20.25 7V8.75H3.75V7C3.75 6.30964 4.30964 5.75 5 5.75H7.25V6.5C7.25 6.91421 7.58579 7.25 8 7.25C8.41421 7.25 8.75 6.91421 8.75 6.5V5.75H15.25ZM3.75 10.25H20.25V19C20.25 19.6904 19.6904 20.25 19 20.25H5C4.30964 20.25 3.75 19.6904 3.75 19V10.25Z"
    fill="#77757D"
  />
</svg> `;
